define('common/ko/fn/isLessThan',[
   'knockout',
   'underscore'
], function (ko, _) {

    ko.subscribable.fn.isLessThan = function (value) {

        return ko.pureComputed({
            owner: this,
            read: function () {

                var currentValue = this();

                if (!_.isNumber(currentValue)) {
                    return false;
                }

                return currentValue < value;

            },
            write: this
        });

    };
});

